import { getLatestArrearsHalfRange } from '@koda/koda-utils/date';
import dayjs from 'dayjs';
import { z } from 'zod';
import { LicenseTypes } from '../../../types/licenses';
import { BasicBusinessInformationSchema, type BusinessInformation } from './types/businessInformation';
import { GeneralPayload } from './types/payloads';

export const ICE_HOCKEY_AND_VOLLEYBALL_CONTENT_PATH = 'licenses.steps.businessInformation.forms.iceHockeyAndVolleyball';

export const iceHockeyAndVolleyballSchema = BasicBusinessInformationSchema.extend({
  spectators: z
    .number({
      required_error: `${ICE_HOCKEY_AND_VOLLEYBALL_CONTENT_PATH}.spectators.validation.required`,
    })
    .int({ message: `${ICE_HOCKEY_AND_VOLLEYBALL_CONTENT_PATH}.spectators.validation.required` })
    .min(1, { message: `${ICE_HOCKEY_AND_VOLLEYBALL_CONTENT_PATH}.spectators.validation.required` }),
});

export type IceHockeyAndVolleyballForm = z.infer<typeof iceHockeyAndVolleyballSchema>;

export const createIceHockeyAndVolleyballDefaults = (): BusinessInformation => ({
  licenseCode: LicenseTypes.IceHockeyAndVolleyball,
});

export const toPayloadIceHockeyAndVolleyball = (
  form: IceHockeyAndVolleyballForm,
  wareNumber: number,
): GeneralPayload => {
  const { start, end } = getLatestArrearsHalfRange();
  return {
    itemNo: String(wareNumber),
    musicStartDate: dayjs(start).format('YYYY-MM-DD'),
    musicEndDate: dayjs(end).format('YYYY-MM-DD'),
    quantity: form.spectators ?? 0,
  };
};
